<template>
  <div class="text-center mt-2">
    <img :src="image" height="100" width="100" v-if="image" alt="No image found for this event" />
  </div>
</template>

<script>
  export default {
    props: {
      item: Object,
    },
    data() {
      return {
        image: '',
      };
    },
    created() {
      this.getImage(this.item);
    },
    methods: {
      async getImage(item) {
        if (!item['ImageURL__c']) {
          return;
        }
        let params = {
          path: item['ImageURL__c'],
        };
        await axios
          .get('/api/get-form-image', { params: params })
          .then(r => {
            this.image = r.data.image;
          })
          .catch(e => {
            console.error(e);
            return;
          });
      },
    },
  };
</script>

<style></style>
